/* rd-expiry W2.3 — Frame-1 pre-warn banner. CSS copied from the confirmed mockup
   (docs/mockups/client-dashboard-redesign/session-recovery-states.html, Frame 1:
   .prewarn / .pw-ic / .pw-tx / .pw-keep). Same token discipline + HONEST swap log as
   ActiveFlowConflictOverlay.module.css:
     · var(--r-md|pill)  → literal px (radii are not injected tokens)
   Every colour/glass/accent surface maps to an existing INJECTED foundation token
   (no :root hex block, no new tokens minted); the white button text is a literal
   (as in Frame 6 / ActiveFlowConflictOverlay). */

/* Slim, NON-blocking top banner — the form stays fully usable underneath. Pinned
   over the page (fixed) so it floats above the scroll body without reflowing it. */
.prewarn {
  position: fixed;
  top: calc(58px + env(safe-area-inset-top, 0px));
  left: 12px;
  right: 12px;
  z-index: 90;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 12px;
  border-radius: 14px;
  background: var(--glass-bg-strong);
  backdrop-filter: var(--glass-blur);
  border: 1px solid rgba(var(--accent-rgb), 0.34);
  box-shadow: var(--glow-amber-soft), 0 10px 26px rgba(0, 0, 0, 0.45);
  animation: pw-drop 0.24s ease;
}
/* Over its container at the container's width, taking no room (the website's desktop checkout column). */
.prewarn.inline {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 30;
}
@keyframes pw-drop {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.pwIc {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  background: radial-gradient(
    circle at 30% 28%,
    rgba(var(--accent-hot-rgb), 0.32) 0%,
    rgba(var(--accent-deep-rgb), 0.16) 100%
  );
  border: 1px solid rgba(var(--accent-rgb), 0.3);
  color: var(--accent-hot);
}
.pwIc svg {
  width: 18px;
  height: 18px;
  stroke-width: 2;
}

.pwTx {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  line-height: 1.3;
}
.pwTx b {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
}
.pwTx span {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.pwKeep {
  appearance: none;
  -webkit-appearance: none;
  border: 0;
  flex-shrink: 0;
  padding: 9px 18px;
  border-radius: 9999px;
  background: var(--accent-orb);
  color: var(--text-on-accent);
  font-size: 13px;
  font-weight: 700;
  box-shadow: var(--glow-amber-soft);
}
.pwKeep:disabled {
  opacity: 0.6;
  pointer-events: none;
}
